// extracted by mini-css-extract-plugin
export default {"container":"MembershipRole_container__tXidc","dropdownSection":"MembershipRole_dropdownSection__584Ws"};